// Standaard starttijd (HH:mm:ss) waarmee een nieuw transport wordt voorgevuld;
// níet het ophaal-/aflever-tijdvenster van opdrachten (zie constants/assignment.ts).
export const DefaultTransportStartTime = '08:00:00';

export enum DefaultDateSettings {
  Today = 0,
  In1BusinessDay = 1,
  In2BusinessDays = 2,
  In3BusinessDays = 3
}

export const DateSettingOptions = [
  { value: DefaultDateSettings.Today, label: 'core.default_date.today' },
  { value: DefaultDateSettings.In1BusinessDay, label: 'core.default_date.in_1_business_day' },
  { value: DefaultDateSettings.In2BusinessDays, label: 'core.default_date.in_2_business_days' },
  { value: DefaultDateSettings.In3BusinessDays, label: 'core.default_date.in_3_business_days' },
]